<template>
  <div>
    <user-detail-title
      first-bread="图片信息"
      second-bread="图片信息"
      third-bread="图片信息添加"
      first-url="/user/pic"
      second-url="/user/pic_info"
      title-name="图片信息添加"
    ></user-detail-title>
    <user-detail-base style="width: 60%">
      <el-form label-position="left" label-width="100px">
        <el-form-item label="图片">
          <el-upload action="/api/photo/uploadFile" :on-success="GetUrlList">
            <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item label="文字描述">
          <el-input type="textarea" :row="3"  v-model="Alist.description" ></el-input>
        </el-form-item>
        <el-form-item label="所属类型">
          <el-select v-model="Alist.type" placeholder="请选择">
            <el-tree :data="MenuTree"
                     node-key="id"
                     :props="defaultProps"
            >
              <div class="" slot-scope="{ node, data }" >
                <el-option  :label="data.name" :value="data.id"></el-option>
              </div>
            </el-tree>
          </el-select>
        </el-form-item>
        <el-form-item label="是否首页显示">
          <el-switch
            v-model="Alist.isHomeShow"
            active-color="#13ce66"
            inactive-color="#ff4949">
          </el-switch>
        </el-form-item>
        <el-button @click="handleAdd">添加</el-button>
      </el-form>
    </user-detail-base>
  </div>
</template>

<script>
  import UserDetailTitle from "../Common/UserDetailTitle";
  import UserDetailBase from "../Common/UserDetailBase";
  export default {
    name: "PicInfoAdd",
    components: {UserDetailBase, UserDetailTitle},
    data(){
      return{
        MenuTree:null,
        defaultProps:{
          children: 'childClassify',
          label: 'name'
        },
        Alist: {
          'type':null,
          'isHomeShow':null,
          'address':null,
          'description':null,
        },//表示Add添加的数据
      }
    },
    created() {
      this.GetTree()
    },
    methods:{
      GetUrlList(file){
        this.Alist.address=file.data;
      },
      GetTree(){
        this.$axios.get('/api/classifyManage/getTree').then(res=>{

          this.MenuTree=res.data.data;
        })
      },
      handleAdd(){
        if(this.Alist.isHomeShow){

        }else {
          this.Alist.isHomeShow=false
        }
        this.$axios.post('/api/photo/addPhoto',this.Alist).then(res=>{
          if(res.data.success == true){
            this.Alist= {
              'type':null,
              'isHomeShow':null,
              'address':null,
              'description':null,
            }//表示Add添加的数据,
            this.$message({
              message:'添加成功',
              type:'success'
            })
          }
        })
      }
    },
  }
</script>

<style scoped>

</style>